<template>
  <div class="reportes-proyectos">
    <div class="content-header">
      <h1 class="content-header-title">Reportes de Proyectos</h1>
      <p class="content-header-subtitle">Genera reportes detallados de proyectos</p>
    </div>
    <b-card>
      <div class="text-center py-5">
        <feather-icon icon="BarChartIcon" size="48" class="text-muted mb-3" />
        <h5 class="text-muted">Reportes de Proyectos</h5>
        <p class="text-muted">Funcionalidad de reportes en desarrollo</p>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ReportesProyectos',
}
</script>

<style lang="scss" scoped>
.reportes-proyectos {
  padding: 1.5rem;
}

.content-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-header-title {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.content-header-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}
</style>
